import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  PropertyDetailsResponse,
  ServerObjResponse,
  ServerResponse,
  VisitSummary,
} from '@models';
import { ModalSuccessService } from '@modules';
import { dateUTC } from '@utilities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PropertyDetailsService {
  private project = environment.PROJECTS;

  constructor(
    private readonly http: HttpClient,
    private readonly modalSuccess: ModalSuccessService
  ) {}

  public getProperty(
    project: string,
    typeProject: string,
    property: string
  ): Observable<PropertyDetailsResponse> {
    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );
    return this.http.get<PropertyDetailsResponse>(`${path}/${property}`);
  }

  public changeLink(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/tourLink`,
      data
    );
  }

  public changeName(
    newName: string,
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(`${path}/${property}/name`, {
      newName,
    });
  }

  public changeSurface(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(`${path}/${property}/surface`, data);
  }

  public changeFeatures(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/features`,
      data
    );
  }

  public changeSettingUp(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/settingUp`,
      data
    );
  }

  public changeMainImage(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/mainImage`,
      data
    );
  }

  public changePlaneImage(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/planeImage`,
      data
    );
  }

  public changeSaleDocuments(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/saleDocument`,
      data
    );
  }

  public changeClientDocuments(
    data: {},
    project: string,
    typeProject: string,
    property: string
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');

    const path = this.project.PROPERTY.replace('{projectId}', project).replace(
      '{typeProjectId}',
      typeProject
    );

    return this.http.patch<ServerResponse>(
      `${path}/${property}/clientDocuments`,
      data
    );
  }

  public getFeatures(
    filter: string,
    typeProject: string
  ): Observable<ServerResponse> {
    const path = this.project.PROJECT_TYPE.replace(
      '{projectTypeId}',
      typeProject
    );
    return this.http.get<ServerResponse>(path, {
      params: {
        filter,
      },
    });
  }

  public getVisitSummary(
    projectId: string,
    typeProjectId: string,
    propertyId: string
  ): Observable<VisitSummary[]> {
    const path = this.project.VISIT_SUMMARY.replace('{projectId}', projectId)
      .replace('{typeProjectId}', typeProjectId)
      .replace('{propertyId}', propertyId);
    return this.http.get<ServerObjResponse>(path).pipe(
      map(({ response }) => {
        return response.map((visit: VisitSummary) => {
          return {
            ...visit,
            dateTime: dateUTC(visit.dateTime),
          };
        });
      })
    );
  }
}
